import React from 'react'
import './CorporateTraining.scss'


const IconCompany = require('app_assets/images/icons/company.png')
const IconSecurity = require('app_assets/images/icons/security.png')
const IconGroup = require('app_assets/images/icons/group.png')
const IconTools = require('app_assets/images/icons/tools.png')

const CorporateTraining = () => {
  return (
    <div className='corporate-training--big-container'>
      <div className='corporate-training--title'>Formación corporativa</div>
      <div className='corporate-training--container'>
        <div className='corporate-training--container-icon'>
          <img alt='Icono corporativo' src={IconCompany}></img>
          <p>Diseñamos a la medida de las necesidades de su organización</p>
        </div>
        <div className='corporate-training--container-icon'>
          <img alt='Icono nuestra huella de formación personas' src={IconSecurity}></img>
          <p>Portafolio sectorial que apoya la competitividad de las empresas</p>
        </div>
        <div className='corporate-training--container-icon'>
          <img alt='Icono nuestra huella de formación personas' src={IconGroup}></img>
          <p>Atención personalizada</p>
        </div>
        <div className='corporate-training--container-icon'>
          <img alt='Icono nuestra huella de formación personas' src={IconTools}></img>
          <p>Contribuiremos a la transformación cultural y sostenibilidad de las empresas</p>
        </div>
      </div>

    </div>
  )
}

export default CorporateTraining
